import {weakMemo} from '@packages/utilities/memo';
import {substituteType as st} from './Checker/TypeCheck';
import {type Type} from './DataTypeDefinition';
import {type Substitution} from './Checker/CheckerState';
import * as Result from './Result';
export {Result};

export {
  getMeta,
  getSystem,
  withSystem,
  withMeta,
  getTypeFromAny,
} from './DataTypeDefinition';

export type {
  ElementDataType,
  TypeConstructor,
  TypeApplication,
  Type,
  MetaAttributes,
  DataTypeSystem,
} from './DataTypeDefinition';

export type {DangerousHooks} from './DangerousHooks';

export {DangerousHooksContext, useDangerousHooks} from './DangerousHooks';

export type {ExpressionPathPart, ExpressionPath} from './ExpressionPath';
export {
  type TypePathPart,
  type TypePath,
  inGeneric,
  inRowConsAtType,
  inRowConsAtTail,
  inTypeApplicationAtCon,
  inTypeApplicationAtArg,
} from './TypePath';

export {matchExpression} from './matchExpression';
export {matchType, getTypeType} from './matchType';

export {
  emptyCheckerState,
  setEnvironment,
  setValues,
  setTypes,
  setComponents,
  getSubstitution,
  getErrors,
  printError,
  getEnvironment,
} from './Checker/CheckerState';

export type {
  CheckerState,
  CheckerEnvironment,
  TypeCheckerError,
  Errors,
} from './Checker/CheckerState';
export {
  inferType,
  checkType,
  setType,
  instantiateGenerics,
  subsumes,
} from './Checker/TypeCheck';
export {TypeCheckerState} from './Checker/TypeCheckerContext';

export {
  jsonExpression,
  parseExpression,
  stringifyExpression,
  parseType,
} from './Json';

export type {
  ParamsType,
  ParamsTypeConfig,
  LockedStyles,
  PropEnum,
  AtomConfigProps,
  Icon,
  AtomConfig,
  NormalizedAtomConfig,
  NormalizedAtomConfigMap,
  StyleAttributeImm,
  GenerateAttributes,
  AttributesObject,
  ContextType,
  PluginsContext,
  EnvironmentContextType,
  AtomRenderProps,
  PluginComponentContextType,
  AttributesMap,
  StyleAttributeObject,
  ClassesList,
  CustomAtomConfigShape,
  AtomConfigShape,
  AtomRender,
  ChildRender,
  ChildrenRender,
} from './Atom';

export {forAtomCreation as Atom, EnumType} from './Atom';

export type {DisplayName} from './DisplayName';
export type {Stoppable} from './GenericExpression/GenericExpressionUtils';
export type {ElementF} from './GenericExpression/GenericExpressionTypes';

export * as Expressions from './Expressions';

export {
  hasErrors,
  hasHoles,
  hasMissingSources,
  hasHolesExpr,
  isExprConfigured,
} from './ContextualExpressionAnalysis';

export * as ElementPreset from './ElementPreset';

export * as ValuePreset from './ValuePreset';

export * as Asset from './Asset';

export * as Component from './Component';

export * as EnvTypes from './EnvTypes';

export * as Variable from './Variable';

export * as VariableMap from './VariableMap';

export * as EvalEnv from './EvalEnv';

export * as Plugins from './Plugins';

export * as TypeImplementation from './TypeImplementation';

export * as Types from './Types';

export * as SiteModules from './SiteModules';

export function tip(message: string, url?: string): void {
  if (process.env.NODE_ENV === 'development') {
    console.log(
      [
        '📎 Platform Tip',
        message,
        ...(url ? [`Learn more » ${url}`] : []),
      ].join('\n\n')
    );
  }
}

/**
 * Apply solutions from a substitution map to Unknowns in a type.
 */
export const substituteType = weakMemo((subst: Substitution) =>
  weakMemo((type: Type) =>
    // We can’t memo the original because it is working with mutable objects
    st(subst)(type)
  )
);
